<template>
  <!--标题-->
  <div class="fill_form mt20 m0 mb30 clearfix">
    <h3 class="form_title clearfix"><span>| </span>调整明细
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th
            v-for="(tableTittle,index) in tableTittles"
            :class="{w_100:index==5}"
          >
            {{tableTittle}}
          </th>
        </tr>
        <template v-for="(item,index) in adjustDetail">
          <tr v-if="item.flag">
            <td><input class = "canChange" type="text" v-model="item.years"></td>
            <td><input class = 'canChange' type="text" v-model="item.average_salary_month"></td>
            <td><input class = 'canChange' type="text" v-model="item.average_salary_month_pay"></td>
            <td><input class = 'canChange' type="text" v-model="item.growth_rate_personal"></td>
            <td><input class = 'canChange' type="text" v-model="item.growth_rate"></td>
            <td><input class = 'canChange' type="text" v-model="item.payment_base_lowest"></td>
            <td><input class = 'canChange' type="text" v-model="item.payment_base_highest"></td>
            <td style="cursor: pointer">
              <span @click="saveItem(index,'adjustDetail')" style="margin-right: 5px;">保存</span>
              <span @click="cancelItem(index,'adjustDetail')">取消</span></td>
          </tr>
          <tr v-else>
            <td>{{item.years}}</td>
            <td>{{item.average_salary_month}}</td>
            <td>{{item.average_salary_month_pay}}</td>
            <td>{{item.growth_rate_personal}}</td>
            <td>{{item.growth_rate}}</td>
            <td>{{item.payment_base_lowest}}</td>
            <td>{{item.payment_base_highest}}</td>
            <td style="cursor: pointer">
              <span @click="changeItem(index,'adjustDetail')" style="margin-right: 5px;">修改</span>
              <span @click="delItem(index,'adjustDetail')">删除</span></td>
          </tr>
        </template>
        <tr>
          <td colspan="8" @click="addAdjustDetail('adjustDetail')" style="cursor: pointer">添加记录</td>
        </tr>
      </table>
    </div>
    <h3 class="form_title clearfix"><span>| </span>调整基本养老金
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th rowspan="2">调整年份</th>
          <th rowspan="2">定额调整</th>
          <th colspan="3">挂钩调整</th>
          <th rowspan="2" colspan="2">高龄倾斜</th>
          <th rowspan="2" class="w_100">操作</th>
        </tr>
        <tr>
          <th>缴费年限（年）</th>
          <th>增加额（元）</th>
          <th>基本养老金水平</th>
        </tr>
        <template v-for="(item,index) in pensionAdjustment">
<!--          修改，2019年前后挂钩调整部分不同，2024年前后高龄倾斜部分不同 -->
          <template v-if="(item.flag&&item.years>=2019)||(item.flag&&AA==2)">
            <tr>
              <template v-if="!item.isNewAdd">
                <td rowspan="3">{{item.years}}年</td>
              </template>
              <template v-else>
                <td rowspan="3"><input class = "canChange1" type="number" v-model="item.years">年</td>
              </template>
              <td rowspan="3"><input class = "canChange1" type="number" v-model="item.account">元/月</td>
              <td>0-15(含15)</td>
              <td><input class = "canChange1" type="number" v-model="item.account_below">元</td>
              <td style='border-bottom:0px'>机关事业单位</td>

              <template v-if="item.years>=2024">
                <td>女 65-70周岁</td>
                <td><input class = "canChange1" type="number" v-model="item.account_advanced_age_f65">元/人·月</td>
              </template>
              <template v-else>
                <td>-</td>
                <td>-</td>
              </template>

              <!--<td rowspan="2"><input class = "canChange1" type="number" v-model="item.same_id"></td>-->
              <td rowspan="3" style="cursor: pointer">
                <span @click="saveItem(index,'pensionAdjustment')" style="margin-right: 5px;">保存</span>
                <span @click="cancelItem(index,'pensionAdjustment')">取消</span></td>
            </tr>
            <tr>
              <td>15-30(含30)</td>
              <td><input class = "canChange1" type="number" v-model="item.account_above">元</td>
              <td rowspan="2"><input class = "canChange1" type="number" v-model="item.institution_proportion">%</td>

              <template v-if="item.years>=2024">
                <td>70-80周岁</td>
                <td><input class = "canChange1" type="number" v-model="item.account_another">元/人·月</td>
              </template>
              <template v-else>
                <td>男 70-80周岁, 女 65-80周岁</td>
                <td><input class = "canChange1" type="number" v-model="item.account_another">元/人·月</td>
              </template>
            </tr>
             <tr>
              <td>30以上</td>
              <td><input class = "canChange1" type="number" v-model="item.account_above_thirty">元</td>

               <td>80周岁</td>
               <td><input class = "canChange1" type="number" v-model="item.account_other">元/人·月</td>
            </tr>
          </template>
          <template v-if="item.flag&&item.years<2019&&AA==1">
            <tr>
              <template v-if="!item.isNewAdd">
                <td rowspan="2">{{item.years}}年</td>
              </template>
              <template v-else>
                <td rowspan="2"><input class = "canChange1" type="number" v-model="item.years">年</td>
              </template>
              <td rowspan="2"><input class = "canChange1" type="number" v-model="item.account">元/月</td>
              <td>0-15(含15)</td>
              <td><input class = "canChange1" type="number" v-model="item.account_below">元</td>
              <td style='border-bottom:0px'>机关事业单位</td>

              <td>男 70-80周岁, 女 65-80周岁</td>
              <td><input class = "canChange1" type="number" v-model="item.account_another">元/人·月</td>

              <td rowspan="2" style="cursor: pointer">
                <span @click="saveItem(index,'pensionAdjustment')" style="margin-right: 5px;">保存</span>
                <span @click="cancelItem(index,'pensionAdjustment')">取消</span></td>
            </tr>
            <tr>
              <td>15以上</td>
              <td><input class = "canChange1" type="number" v-model="item.account_above">元</td>
              <td><input class = "canChange1" type="number" v-model="item.institution_proportion">%</td>

              <td>80周岁</td>
              <td><input class = "canChange1" type="number" v-model="item.account_other">元/人·月</td>
            </tr>
          </template>

<!--          查看，2019年前后挂钩调整部分不同，2024年前后高龄倾斜部分不同-->
          <template v-else-if='!item.flag&&item.years>=2019'>
            <tr>
              <td rowspan="3">{{item.years}}年</td>
              <td rowspan="3">{{item.account}}元/月</td>
              <td>0-15(含15)</td>
              <td>{{item.account_below}}元</td>
              <td style='border-bottom:0px'>机关事业单位</td>

              <template v-if="item.years>=2024">
                <td>女 65-70周岁</td>
                <td>{{item.account_advanced_age_f65}}元/人·月</td>
              </template>
              <template v-else>
                <td>-</td>
                <td>-</td>
              </template>

              <!--<td rowspan="2">{{item.same_id}}</td>-->
              <td rowspan="3" style="cursor: pointer">
                <span @click="changeItem(index,'pensionAdjustment')" style="margin-right: 5px;">修改</span>
                <span @click="delItem(index,'pensionAdjustment')">删除</span></td>
            </tr>
            <tr>
              <td>15-30(含30)</td>
              <td>{{item.account_above}}元</td>
              <td rowspan="2">{{item.institution_proportion}}%</td>

<!--              2024：女65-70是12.5元，男女70-80是25元，80以上25元-->
              <template v-if="item.years>=2024">
                <td>70-80周岁</td>
                <td>{{item.account_another}}元/人·月</td>
              </template>
              <template v-else>
                <td>男 70-80周岁, 女 65-80周岁</td>
                <td>{{item.account_another}}元/人·月</td>
              </template>

            </tr>
            <tr>
              <td>30以上</td>
              <td>{{item.account_above_thirty}}元</td>

              <td>80周岁</td>
              <td>{{item.account_other}}元/人·月</td>
            </tr>
          </template>
          <template v-else-if='!item.flag&&item.years<2019'>
            <tr>
              <td rowspan="2">{{item.years}}年</td>
              <td rowspan="2">{{item.account}}元/月</td>
              <td>0-15(含15)</td>
              <td>{{item.account_below}}元</td>
              <td style='border-bottom:0px'>机关事业单位</td>

              <td>男 70-80周岁, 女 65-80周岁</td>
              <td>{{item.account_another}}元/人·月</td>

              <td rowspan="2" style="cursor: pointer">
                <span @click="changeItem(index,'pensionAdjustment')" style="margin-right: 5px;">修改</span>
              </td>
            </tr>
            <tr>
              <td>15以上</td>
              <td>{{item.account_above}}元</td>
              <td>{{item.institution_proportion}}%</td>

              <td>80周岁</td>
              <td>{{item.account_other}}元/人·月</td>
            </tr>
          </template>
        </template>
        <tr>
          <td colspan="12" style="cursor: pointer" @click="addAdjustDetail('pensionAdjustment')">添加记录</td>
        </tr>
      </table>
    </div>
    <h3 class="form_title clearfix"><span>| </span>国办发【2015】3号文增资标准
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th colspan="6"></th>
          <th>增资标准<br/>（单位：元/月）</th>
          <!--<th>操作</th>-->
        </tr>
        <tr>
          <td></td>
          <td>省部级及以上</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>1100</td>
          <!--<td rowspan="7">修改</td>-->
        </tr>
        <tr>
          <td></td>
          <td>厅局级</td>
          <td>专技1-4级</td>
          <td>教授及相当职位</td>
          <td></td>
          <td></td>
          <td>700</td>
        </tr>
        <tr>
          <td></td>
          <td>副局级</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>580</td>
        </tr>
        <tr>
          <td>管理五、六级</td>
          <td>县处级</td>
          <td>专技5-7级</td>
          <td>副教授及相当职位</td>
          <td></td>
          <td></td>
          <td>460</td>
        </tr>
        <tr>
          <td>管理七、八级</td>
          <td>乡科级</td>
          <td>专技8-10级</td>
          <td>讲师及相当职位</td>
          <td>事业单位工人1-2级</td>
          <td>高级技师、技师</td>
          <td>350</td>
        </tr>
        <tr>
          <td>管理九、十级</td>
          <td>科员、办事员</td>
          <td>专技11-12级</td>
          <td>助教及以下</td>
          <td>事业单位工人3-5级</td>
          <td>高级工以下及普通工</td>
          <td>260</td>
        </tr>
        <tr>
          <td></td>
          <td>退职</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>260</td>
        </tr>
      </table>
    </div>
    <msgTips v-show="showFlag" @confirm="layerConfirm(index,type)" @cancel="layerCancel" title="提示">
      <div class="layer_content" v-if='type=="pensionAdjustment"'>
        <p class="layer_content_tip">该数据删除后将会影响退休人员养老金计算</p>
        <p>确定删除该记录？</p>
    </div>
      <p class="layer_content" v-else>确定删除该记录？</p>
    </msgTips>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
  </div>


  <!-- 标题 end-->
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import msgTips from '../../components/layer/msgTips'
  import toastTips from '../../components/layer/toastTips'
  export default{
    name:'configInfo',
    components:{
      msgTips,
      toastTips
    },
    data () {
      return {
        tableTittles:['年度','全省在岗职工月平均工资（待遇）','全省在岗职工月平均工资（缴费）','个人养老金利率','工资增长率','最低缴费基数','最高缴费基数','操作'],
        adjustDetail:[],
        pensionAdjustment:[],
//        getIncrreaseAccount:[],
        showFlag:false,
        originalAdjustDetail:'',
        originalPensionAdjustment:'',
        index:null,
        type:'',
        toast:false,
        toastContent:'',
        pensionType:'',
        AA:1,
      }
    },
    mounted:function(){
      var that = this;
      function getAverageSalary() {
        return axios.get('/averageSalary/getList');
      }
      function getpensionAdjustment() {
        return axios.get('/pensionAdjustment/getList');

      }
      axios.all([getAverageSalary(),getpensionAdjustment()])
        .then(axios.spread(function(salary,pensionAdjustment){
          if(salary.data.code == 22000){
            that.adjustDetail = salary.data.result;
          }else if(salary.data.code==50001){
            window.location.href='/#/login';
          }
          if(pensionAdjustment.data.code == 22000){
            that.pensionAdjustment = pensionAdjustment.data.result;
            let pensionAdjustmentArr = that.pensionAdjustment;
            let  tempArr = [];
            for (var i=0,j=pensionAdjustmentArr.length;i<j;i++){
              tempArr.push(pensionAdjustmentArr[i].years)

            }
            window.sessionStorage.setItem('key',tempArr)
          }else if(pensionAdjustment.data.code==50001){
            window.location.href='/#/login';
          }
        }));

    },
    methods:{
      changeItem:function(index,type){
        this.originalAdjustDetail= JSON.stringify(this.adjustDetail);
        this.originalPensionAdjustment=JSON.stringify(this.pensionAdjustment);
        switch (type){
          case 'adjustDetail':
            this.$set(this.adjustDetail[index],"flag",true);
                break;
          case 'pensionAdjustment':
            this.$set(this.pensionAdjustment[index],"flag",true);
                break;
        }

      },
      saveItem:function(index,type){
        var that = this;
        switch (type){
          case 'adjustDetail':
            if(this.adjustDetail[index].isNewAdd){
                  axios.post('/averageSalary/create',qs.stringify(
                    that.adjustDetail[that.adjustDetail.length-1]
                  )).then((response)=>{
                    if(response.data.code == 22000){
//                      that.adjustDetail.push(response.data.result);
                      this.$set(this.adjustDetail[index],"flag",false);
                      this.adjustDetail[index].isNewAdd=false;
                      window.location.reload();
                    }else if(response.data.code==50001){
                      window.location.href='/#/login';
                    }else{
                      that.toast=true;
                      that.toastContent=response.data.message=='参数异常！'?'请填写信息':response.data.message;
                      setTimeout(function(){
                        that.toast=false;
                        that.toastContent='';
                      },3000)
                    }
                });

            }else{
              axios.post('/averageSalary/update',qs.stringify(
                that.adjustDetail[index]
              )).then((response)=>{
                if(response.data.code == 22000){
                  that.adjustDetail = response.data.result;
                  this.$set(this.adjustDetail[index],"flag",false);
                }else if(response.data.code==50001){
                  window.location.href='/#/login';
                }else{
                  that.toast=true;
                  that.toastContent=that.toastContent=response.data.message=='参数异常！'?'请填写信息':response.data.message;
                  setTimeout(function(){
                    that.toast=false;
                    that.toastContent='';
                  },3000)
                }
              });
            }

            break;
          case 'pensionAdjustment':
            if(this.pensionAdjustment[index].isNewAdd){
              axios.post('/pensionAdjustment/create',qs.stringify(
                that.pensionAdjustment[that.pensionAdjustment.length-1]
              )).then((response)=>{
                if(response.data.code == 22000){
                  this.$set(this.pensionAdjustment[index],"flag",false);
                  window.location.reload();
                }else if(response.data.code==50001){
                  window.location.href='/#/login';
                }else{
                  that.toast=true;
                  that.toastContent=that.toastContent=response.data.message=='参数异常！'?'请填写信息':response.data.message;
                  setTimeout(function(){
                    that.toast=false;
                    that.toastContent='';
                  },3000)
                }
              });

            }else{
              axios.post('/pensionAdjustment/update',qs.stringify(
                that.pensionAdjustment[index]
              )).then((response)=>{
                if(response.data.code == 22000){
                  that.pensionAdjustment = response.data.result;
                  this.$set(this.pensionAdjustment[index],"flag",false);
                }else if(response.data.code==50001){
                  window.location.href='/#/login';
                }else{
                  that.toast=true;
                  that.toastContent=that.toastContent=response.data.message=='参数异常！'?'请填写信息':response.data.message;
                  setTimeout(function(){
                    that.toast=false;
                    that.toastContent='';
                  },3000)
                }
              });
            }
            break;

        }
      },
      addAdjustDetail:function(type){
        switch (type){
          case 'adjustDetail':
            this.adjustDetail.push({
              average_salary_month: "",
              growth_rate: "",
              growth_rate_personal: "",
              flag:true,
              isNewAdd:true,
              years: ""
            });
            break;
          case 'pensionAdjustment':
          this.AA=2;
            this.pensionAdjustment.push({
              years: "",
              account: "",
              account_below: "",
              account_above: "",
              account_above_thirty:"",
              flag:true,
              isNewAdd:true,
              account_lowest: "",
              institution_proportion: "",
              account_another: "",
              account_other: "",
              account_advanced_age_f65: "",
              same_id: ""
            });
            break;

        }

      },
      cancelItem:function(index,type){
        switch (type){
          case 'adjustDetail':
              if(this.adjustDetail[index].isNewAdd){
                this.adjustDetail.splice(index,1);
              }else{
                var oAdj=JSON.parse(this.originalAdjustDetail);
                for(var key in this.adjustDetail[index]){
                  this.adjustDetail[index][key]=oAdj[index][key];
                }
                this.adjustDetail[index].flag=false;
              }
            break;
          case 'pensionAdjustment':
            if(this.pensionAdjustment[index].isNewAdd){
              this.pensionAdjustment.splice(index,1);
            }else{
              var oPadj = JSON.parse(this.originalPensionAdjustment);
              for(var key in this.pensionAdjustment[index]){
                this.pensionAdjustment[index][key]=oPadj[index][key];
              }
              this.pensionAdjustment[index].flag=false;
            }
            break;

        }
      },
      delItem:function(index,type){
        this.showFlag=true;
        this.index=index;
        this.type=type;
      },
      layerConfirm:function (index,type){
        var that=this;
        switch (type){
          case 'adjustDetail':
              axios.post('/averageSalary/delete',qs.stringify(
                {id:that.adjustDetail[index].id}
              )).then((response)=>{
                if(response.data.code==22000){
                  that.adjustDetail.splice(index,1);
                  that.showFlag=false;

                  let pensionAdjustmentArr = that.pensionAdjustment;
                  let  tempArr = [];
                  for (var i=0,j=pensionAdjustmentArr.length;i<j;i++){
                    tempArr.push(pensionAdjustmentArr[i].years)
                  }
                  window.sessionStorage.setItem('key',tempArr)

                }else if(response.data.code==50001){
                  window.location.href='/#/login';
                }else{
                  that.toast=true;
                  that.toastContent=response.data.message;
                  setTimeout(function(){
                    that.toast=false;
                    that.toastContent='';
                  },3000)
                }
              });
            break;
          case 'pensionAdjustment':
            axios.post('/pensionAdjustment/delete',qs.stringify(
              {id:that.pensionAdjustment[index].id}
            )).then((response)=>{
              if(response.data.code==22000){
                this.pensionAdjustment.splice(index,1);
                that.showFlag=false;

                let pensionAdjustmentArr = that.pensionAdjustment;
                let  tempArr = [];
                for (var i=0,j=pensionAdjustmentArr.length;i<j;i++){
                  tempArr.push(pensionAdjustmentArr[i].years)
                }
                window.sessionStorage.setItem('key',tempArr)

              }else if(response.data.code==50001){
                window.location.href='/#/login';
              }else{
                that.toast=true;
                that.toastContent=response.data.message;
                setTimeout(function(){
                  that.toast=false;
                  that.toastContent='';
                },3000)
              }
            });
            break;

        }


      },
      layerCancel:function(){
        this.showFlag=false;
      }
    }
  }
</script>
<style>
  .table_outer_box{
    margin-bottom: 30px;
  }
  td,th{
    border-right:1px solid #e1e7f6;
    text-align: center;
    padding-right: 10px !important;
  }
  .table{
    border-right: none;
  }
  .canChange1{
    width: 50px!important;
    font-size: 12px;
    text-align: center;
    border:1px solid #e1e7f6;
  }
  .layer_content{
    text-align: center;
    line-height: 80px;
    font-size: 16px;
  }
  div.layer_content{
      padding:10px 0 0;
  }
  div.layer_content p{
    text-align: center;
    line-height: 20px;
    font-size: 16px;
  }
  div.layer_content p.layer_content_tip{
    font-size: 14px;
    background:#ffb8004a;
    padding:10px 0px;
    margin:0 10px 20px;
  }
  .w_100{
    width: 100px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pension_params/configInfo.vue